import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAddLesson } from "../service/add-lesson/fetchAddLesson";

interface ErrorSuccessState {
    success: boolean;
    isLoading: boolean;
    error: string | null;
    errors: {
        [key: string]: string[];
    };
}

const initialState: ErrorSuccessState = {
    success: false,
    isLoading: false,
    error: null,
    errors: {},
};

const addLessonSlice = createSlice({
    name: 'addLesson',
    initialState,
    reducers: {
        setError: (state, action: PayloadAction<{ success: boolean; error: string; errors: { [key: string]: string[] } }>) => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
            state.success = false;
        },
        clearErrors: (state) => {
            state.error = null;
            state.errors = {};
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAddLesson.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(fetchAddLesson.fulfilled, (state) => {
                state.isLoading = false;
                state.error = null;
                state.success = true;
                state.errors = {};
            })
            .addCase(fetchAddLesson.rejected, (state, action) => {
                const errorResponse = action.payload as {
                    success: boolean;
                    error: string;
                    errors: { [key: string]: string[] };
                };
                if (errorResponse) {
                    state.isLoading = false;
                    state.error = errorResponse.error || 'An error occurred';
                    state.errors = errorResponse.errors || {};
                    state.success = false;
                }
            });
    },
});

export const { setError, clearErrors  } = addLessonSlice.actions;

export const addLessonReducer = addLessonSlice.reducer;
